import { EyeOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { Button, Form, Input } from "antd";
import { Card, Col, Collapse, List, Row } from "antd";
import { FC } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { Panel } = Collapse;

type ViewExtensionOfStayEchsProps = {
  enhancementsList: any;
  handleOpen: any;
  closeViewAddedEnhancement: any;
  viewEnhancement: boolean;
  isFetchingEnhancementData: boolean;
};

const ViewExtensionOfStayEchs: FC<ViewExtensionOfStayEchsProps> = (props) => {
  return (
    <Modal
      loading={props?.isFetchingEnhancementData}
      title={
        <div>
          <span style={{ fontSize: "1rem", fontWeight: "600" }}>
            EXTENSION OF STAY
          </span>
        </div>
      }
      centered
      width={2000}
      open={props?.viewEnhancement}
      onCancel={props?.closeViewAddedEnhancement}
      footer={null}
      style={{ boxShadow: "0px 4px 20px 0px #00000040", width: "149%" }}
      className="new-view-enhancement-ihx"
    >
      <List
        grid={{ gutter: 16, column: 1 }}
        dataSource={props?.enhancementsList}
        renderItem={(item: any, index) => (
          <List.Item>
            <Card
              className="enhancement-card"
              title={`Extension Of Stay-${props?.enhancementsList?.length - index}`}
              style={{ cursor: "pointer", backgroundColor: "white" }}
            >
              <Collapse defaultActiveKey={["1"]}>
                <Panel header="Procedures" key="1">
                  <Form>
                    <Row
                      key={item?.id}
                      gutter={[16, 16]}
                      align="top"
                      style={{
                        border: "1px solid #008B8B",
                        padding: "10px 20px",
                        borderRadius: "16px",
                        marginBottom: "0.8rem",
                        background: "white",
                        boxShadow: "0px 2px 8px 0px #00000040",
                      }}
                    >
                      <Col span={12}>
                        <Form.Item
                          label="Range of Stay Extension"
                          name={"rangeOfStayExtension"}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Input
                            defaultValue={item?.rangeOfStayExtension}
                            disabled={true}
                            style={{ color: "black" }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          label="Proposed New Date of Discharge"
                          name={"proposedNewDateOfDischarge"}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <DatePicker
                            defaultValue={
                              item?.proposedNewDateOfDischarge
                                ? dayjs(item.proposedNewDateOfDischarge)
                                : null
                            }
                            disabled={true}
                            style={{ width: "100%", borderRadius: "5px" }}
                            placeholder="Select Date"
                            format="DD-MM-YYYY"
                          />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          label="Diagnosis"
                          name={"diagnosis"}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Input.TextArea
                            style={{
                              borderRadius: "5px",
                              color: "black",
                            }}
                            placeholder="Enter Diagnosis"
                            disabled={true}
                            defaultValue={item?.diagnosis}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          label="Remarks"
                          name={"remark"}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Input.TextArea
                            style={{
                              borderRadius: "5px",
                              color: "black",
                            }}
                            placeholder="Enter Remark"
                            disabled={true}
                            defaultValue={item?.remark}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </Panel>

                <Panel header="Documents" key="2">
                  {item?.documentUrls &&
                  item?.documentUrls?.length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: 10,
                      }}
                    >
                      {item?.documentUrls
                        ?.filter(
                          (doc: any) =>
                            doc?.documentLabelType?.toUpperCase() === 'GEO-TAGGED PHOTO OF PATIENT' || doc?.documentLabelType?.toUpperCase() === 'STAY EXTENSION DOCUMENTS'
                        )
                        ?.map((doc: any) => (
                          <div
                            key={doc.id}
                            style={{
                              border: "1px solid #eee",
                              padding: 10,
                              borderRadius: 8,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>
                              {doc.documentLabelType || doc.documentName}
                            </span>
                            <Button
                              type="link"
                              icon={<EyeOutlined />}
                              onClick={() =>
                                props?.handleOpen(
                                  item?.documentUrls,
                                  doc?.documentLabelType,
                                )
                              }
                            />
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      NO DOCUMENT UPLOADED
                    </div>
                  )}
                </Panel>
              </Collapse>
            </Card>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ViewExtensionOfStayEchs;
